<template>
  <b-modal
    id="confirmation-modal"
    ref="confirmationModal"
    :title="titleComputed"
    :ok-title="okButtonTitle"
    ok-variant="primary"
    :cancel-title="cancelButtonTitle"
    cancel-variant="secondary"
    @ok="ok"
    @cancel="cancel"
    @close="cancel"
    @hidden="cancel"
    @shown="onShow"
    centered
    :no-close-on-backdrop="noCloseOnBackdrop"
    >
    <div class="my-3" v-html="messageComputed"></div>
      <template v-if="isComment">
        <form
        id="form"
        novalidate
        class="position-relative"
        @submit.prevent
      >
        <LmTextArea
        v-if="type === 'textarea'"
        id="comment"
        v-model="form.comment"
        :label="$t(labelComment)"
        :v="isCommentValidationRequired ? customValidation : {value:false}"
        ref="lmTextArea"
        />
        <input
          v-if="type === 'token'"
          autocomplete="off"
          class="my-5 token"
          :v="isCommentValidationRequired ? customValidation : {value:false}"
          ref="lmTextArea"
          v-model.trim="form.comment"
          maxlength='6'
        />
      </form>
    </template>

  </b-modal>
</template>

<script>
import LmTextArea from '@/components/form/elements/LmTextArea.vue'
export default {
  components: {
    LmTextArea
  },
  data () {
    return {
      id: null,
      messageData: '',
      titleData: '',
      isComment: false,
      isCommentValidationRequired: false,
      mustValidate: false,
      labelComment: '',
      initialForm: {},
      type: 'textarea',
      form: {
        comment: '',
        id: null
      },
      okButtonTitle: this.$t('Ok'),
      cancelButtonTitle: this.$t('cancel')
    }
  },
  computed: {
    customValidation () {
      return {
        required: this.isCommentValidationRequired,
        $error: !this.form.comment && this.mustValidate
      }
    },
    messageComputed () {
      return this.messageData || this.message
    },
    titleComputed () {
      return this.titleData || this.title
    }
  },
  props: {
    message: {
      type: String,
      default: function () {
        return this.$t('are_you_sure')
      }
    },
    title: {
      type: String,
      default: function () {
        return this.$t('are_you_sure')
      }
    },
    okTitle: {
      type: String,
      default: null
    },
    cancelTitle: {
      type: String,
      default: null
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    lmShow () {
      this.$refs['confirmationModal'].show()
      return new Promise((resolve, reject) => {
        this.$on('ok', (data) => {
          if (this.isComment) {
            resolve(data?.comment || 'ok')
          } else {
            resolve('ok')
          }
        })
        this.$on('cancel', () => {
          // eslint-disable-next-line
          reject('cancel')
        })
      })
    },
    setMessageProps (message) {
      this.messageData = message
    },
    setTitleProps (title) {
      this.titleData = title
    },
    setIsCommentProps (isComment, isCommentValidationRequired, labelComment, type = 'textarea') {
      if (isComment) {
        this.type = type
        this.isComment = isComment
        this.labelComment = labelComment
        this.isCommentValidationRequired = isCommentValidationRequired
      }
    },
    setId (id = null) {
      this.form.id = id
    },
    ok (bvModalEvt) {
      this.mustValidate = this.isCommentValidationRequired
      if (this.isComment) {
        if (this.customValidation.$error) {
          bvModalEvt.preventDefault()
        } else {
          this.$emit('ok', this.form)
          this.mustValidate = false
        }
      } else {
        this.$emit('ok')
      }
    },
    cancel () {
      if (this.isComment) {
        this.isComment = false
        this.isCommentValidationRequired = false
        this.form = JSON.parse(this.initialForm)
        this.$emit('cancel')
      } else {
        this.mustValidate = false
        this.$emit('cancel')
      }
    },
    onShow () {
      this.okButtonTitle = this.okTitle || this.$t('Ok')
      this.cancelButtonTitle = this.cancelTitle || this.$t('cancel')
    }
  },
  created () {
    this.initialForm = JSON.stringify(this.form)
  }
}
</script>

<style lang="sass" scoped>

$char-w: 1ch
$gap: .5*$char-w
$n-char: 6
$in-w: $n-char*($char-w + $gap)

input.token
  display: block
  margin: 2em auto
  border: none
  padding: 0
  width: $in-w
  background: repeating-linear-gradient(90deg, dimgrey 0, dimgrey $char-w, transparent 0, transparent $char-w + $gap) 0 100%/ #{$in-w - $gap} 2px no-repeat
  font: 5ch droid sans mono, consolas, monospace
  letter-spacing: $gap

  &:focus
    outline: none
</style>
